import { Grid } from "@mui/material";
import { FormSelect } from "../../../components/hook-form/form-select.component";
import { FormAutoCompleteSelectDynamic } from "../../../components/hook-form/form-autocomplete-select.dynamic.component";
import { useFormContext, useWatch } from "react-hook-form";
import { useEffect, useState } from "react";
import { SelectFieldOption } from "../../../components/hook-form/hook-form-error";
import { rebateCompanyApiKeyStore } from "../../../api/masters/rebate-company-api-key-store";

const rebateOptions1: SelectFieldOption[] = [
    { value: 'processing', label: 'Processing', isDefault: false },
    { value: 'notProcessing', label: 'Not Processing', isDefault: false },
    { value: 'notqualify', label: 'Does Not Qualify', isDefault: false },
    { value: 'norebate', label: 'No Rebate Program Available', isDefault: false },
];
const rebateOptions2: SelectFieldOption[] = [
    { value: 'notProcessing', label: 'Not Processing', isDefault: false },
    { value: 'notqualify', label: 'Does Not Qualify', isDefault: false },
    { value: 'norebate', label: 'No Rebate Program Available', isDefault: false },
];

interface UnitRebate {
    project: any;
}

export const UnitRebate = ({ project }: UnitRebate) => {
    const { setValue, getValues } = useFormContext();
    const [rebateValue, setRebateValue] = useState<string>();

    useWatch({
        name: ['rebates'] || [],
    });

    useEffect(() => {
        if (project) setRebateValue(project?.rebates ?? '');
    }, [project])

    const handleRebate = (value: any) => {
        if (value !== 'processing') {
            setValue('rebateCompanies', null);
        }
    };

    return (
        <>
            <Grid item lg={3}>
                <FormSelect
                    name="rebates"
                    label="Rebates"
                    onChange={handleRebate}
                    options={rebateValue == 'processing' ? rebateOptions1 : rebateOptions2} />
            </Grid>
            <Grid item lg={3}>
                <FormAutoCompleteSelectDynamic
                    name="rebateCompanies"
                    label="Rebate/Utility Company"
                    disabled={getValues('rebates') == 'processing' ? false : true}
                    getQueryKeyConfig={() =>
                        rebateCompanyApiKeyStore.getUtilRebateMappings('project', project?.projectID)
                    }
                    optionsValueKey="utilRebateCompanyID"
                    optionsLabelKey="utilRebateCompanyName"
                />
            </Grid>
        </>
    );
}